const getProductListing = state => state.productViewReducer

export const getCategory = state => getProductListing(state).productCategoryDetails?.catalogGroupView?.[0]
export const getCategoryBreadCrumbTrail = state => getProductListing(state).breadCrumbTrail?.breadCrumbTrailEntryView
export const getProducts = state => getProductListing(state).productViewDetails?.catalogEntryView
export const getProductCount = state => getProductListing(state).productViewDetails?.recordSetTotal
export const getFacets = state => getProductListing(state).productViewDetails?.facetView?.filter(facet => facet?.extendedData?.ffield3?.includes('C'))